import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FiDownload, FiMoreHorizontal, FiPlus, FiSearch } from 'react-icons/fi';
import { Dropdown, FormControl, FormGroup } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import Layout from 'components/Layout';
import Loading from 'components/Loading';
import Modal from 'components/Modal';
import CalendarList from 'components/Calendars';
import CalendarEditModal from 'components/Calendars/CalendarEditModal';
import { hideModal, showModal } from 'actions/modalActions';
import * as calendarsActions from 'actions/calendarsActions';

class SystemCalendars extends Component {
	state = { searchCalendar: '' };

	componentDidMount() {
		this.props.getSystemDayTypes();
		this.props.getAllSystemCalendars();
	}

	handleChangeSearch = (event) => {
		const searchCalendar = event.target.value;
		this.setState({ searchCalendar }, () => {
			this.props.getAllSystemCalendars(searchCalendar);
		});
	}

	closeModal = () => this.props.hideModal();

	openNewCalendarModal = () => {
		this.props.showModal({
			open: true,
			title: this.props.t('calendars.system.newCalendar'),
			style: { width: '670px' },
			content: <CalendarEditModal system handleClose={this.closeModal} />,
			closeModal: this.closeModal,
		}, 'edit');
	}

	render() {
		return (
			<>
				<Layout configSidebar className="page-calendars" context="calendars">
					<div className="heading">
						<h1 className="title">{this.props.t('calendars.system.title')}</h1>
						<div className="heading-filters">
							<FormGroup className="form-group form-search" controlId="searchCalendar">
								<FormControl
									type="text"
									placeholder={this.props.t('common.searchPlaceholder')}
									value={this.state.searchCalendar}
									onChange={this.handleChangeSearch}
								/>
								<FiSearch />
							</FormGroup>
						</div>
						<div className="heading-actions">
							<button
								type="button"
								title={this.props.t('calendars.system.newCalendar')}
								onClick={this.openNewCalendarModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>
							<Dropdown>
								<Dropdown.Toggle variant="action"><FiMoreHorizontal /></Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item as="button" onClick={() => this.props.history.push('/calendars-system/import')}>
										<FiDownload /> {this.props.t('calendars.system.importSpecialDays')}
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>

					{this.props.system_loading
						? <Loading />
						: <CalendarList system />}
				</Layout>
				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = ({ calendarsReducer }) => calendarsReducer;

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => dispatch(showModal({ modalProps, modalType })),
	getAllSystemCalendars: (query) => dispatch(calendarsActions.getAllSystemCalendars(query)),
	getSystemDayTypes: () => dispatch(calendarsActions.getSystemDayTypes()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SystemCalendars));
